"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasStripeIdInputChanged = void 0;
function hasStripeIdInputChanged(company, stripeIdInputValue) {
    if (company.credit_card_key !== stripeIdInputValue)
        return true;
    return false;
}
exports.hasStripeIdInputChanged = hasStripeIdInputChanged;
